<ng-container *ngIf="userId$ | async as userId">
  <ng-template #container>
    <div class="left-column">
      <app-profile-info [userId]="userId"></app-profile-info>

      <app-references
        [userId]="userId"
        [references]="referencesProfiles$ | async"
        (submitReference)="addReference($event, userId)"
        *appHideForGuest
      >
      </app-references>
    </div>
    <div class="middle-column d-md-block">
      <app-profile-posts [userId]="userId"></app-profile-posts>
    </div>
    <div class="right-column d-none d-xl-block">
      <app-suggested-profiles-right-bar
        [profiles]="suggestedProfiles$ | async"
        (connect)="onProfileConnect($event)"
        (disconnect)="onProfileDisconnect($event)"
      >
      </app-suggested-profiles-right-bar>

      <!-- <app-profile-suggestions [userId]="userId$ | async"></app-profile-suggestions> -->
    </div>
  </ng-template>
  <div
    class="container d-block d-md-flex"
    appMobileView
    *ngIf="profileId$ | async | isCurrentUser:'mangled' | async; else other"
    [tabs]="{left: 'About profile', middle: 'My posts'}"
  >
    <ng-container *ngTemplateOutlet="container"></ng-container>
  </div>
  <ng-template #other>
    <div class="container d-block d-md-flex" appMobileView [tabs]="{left: 'About profile', middle: 'All posts'}">
      <ng-container *ngTemplateOutlet="container"></ng-container>
    </div>
  </ng-template>
</ng-container>
